export const RICH_TEXT_EDITOR_1_CONSTANTS = {
  DEFAULT_ROW: {
    id: "",
    content: "",
    article_band_background_color: "",
    background_color: "#FFFFFF",
    enable_padding: true,
    padding_x: "",
    padding_y: "",
    status: false,
  },

  RICH_TEXT_EDITOR_FIELDS_CONFIG: [
    {
      fieldName: "content",
      label: "Content",
      value: "",
      valueType: "string",
      filedType: "RICH_TEXT_EDITOR",
      placeholder: "Enter content",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "article_band_background_color",
      label: "Blog page — full article band background",
      value: "",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Leave blank to use “Background color” below",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "background_color",
      label: "Background color (fallback)",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#FFFFFF",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "enable_padding",
      label: "Enable Padding",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable padding around content",
      required: false,
      defaultValue: true,
    },
    {
      fieldName: "padding_x",
      label: "Horizontal Padding — X axis (px)",
      value: "",
      valueType: "number",
      filedType: "INPUT",
      placeholder: "e.g. 36 (leave blank for default)",
      description: "Left/right padding in pixels. Only applies when padding is enabled.",
      required: false,
      defaultValue: "",
      dependsOn: "enable_padding",
    },
    {
      fieldName: "padding_y",
      label: "Vertical Padding — Y axis (px)",
      value: "",
      valueType: "number",
      filedType: "INPUT",
      placeholder: "e.g. 40 (leave blank for default)",
      description: "Top/bottom padding in pixels. Only applies when padding is enabled.",
      required: false,
      defaultValue: "",
      dependsOn: "enable_padding",
    },
    {
      fieldName: "status",
      label: "Status",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable rich text editor",
      required: false,
      defaultValue: false,
    },
  ],

  METADATA_FIELDS: [],
};


